var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommentsSolid1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 96,
    viewBox: "0 0 120 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_215_100)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.0001 66C60.5438 66 78.0001 51.225 78.0001 33C78.0001 14.775 60.5438 0 39.0001 0C17.4563 0 9.89581e-05 14.775 9.89581e-05 33C9.89581e-05 40.2375 2.75635 46.9312 7.4251 52.3875C6.76885 54.15 5.79385 55.7063 4.7626 57.0188C3.8626 58.1813 2.94385 59.0812 2.26885 59.7C1.93135 60 1.6501 60.2438 1.4626 60.3938C1.36885 60.4688 1.29385 60.525 1.25635 60.5437L1.21885 60.5813C0.187599 61.35 -0.262401 62.7 0.150099 63.9187C0.562599 65.1375 1.70635 66 3.0001 66C7.0876 66 11.2126 64.95 14.6438 63.6562C16.3688 63 17.9813 62.2688 19.3876 61.5188C25.1439 64.3688 31.8376 66 39.0001 66ZM84.0001 33C84.0001 54.0563 65.4188 69.9187 43.4063 71.8125C47.9626 85.7625 63.0751 96 81.0001 96C88.1626 96 94.8563 94.3688 100.631 91.5188C102.038 92.2688 103.631 93 105.356 93.6562C108.788 94.95 112.913 96 117 96C118.294 96 119.456 95.1562 119.85 93.9187C120.244 92.6813 119.813 91.3313 118.763 90.5625L118.725 90.525C118.688 90.4875 118.613 90.45 118.519 90.375C118.331 90.225 118.05 90 117.713 89.6812C117.038 89.0625 116.119 88.1625 115.219 87C114.188 85.6875 113.213 84.1125 112.556 82.3687C117.225 76.9312 119.981 70.2375 119.981 62.9812C119.981 45.5812 104.063 31.3125 83.8689 30.075C83.9438 31.0312 83.9814 32.0062 83.9814 32.9812L84.0001 33Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_215_100"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 96,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentsSolid1);
export default __webpack_public_path__ + "static/media/comments-solid 1.36963804f82e5fd02511dfcc2d591568.svg";
export { ForwardRef as ReactComponent };